/**
 * initMenu
 * ======================
 */
const initMenu = () => {
  const nav = document.querySelector(".mobile-navigation");
  const burger = document.querySelector(".burger");
  const links = document.querySelectorAll(
    ".mobile-navigation .menu-item:not(.sub-menu .menu-item)"
  );
  const subMenuMobileLinks = document.querySelectorAll(
    ".mobile-navigation .menu-item-has-children"
  );

  // Toggle the mobile nav when the hamburger icon is clicked
  if (burger) {
    burger.addEventListener("click", () => {
      nav.classList.toggle("is-menu-open");
      // Toggle the hamburger animation
      burger.classList.toggle("is-burger-active"); // <-- Class to activate the hamburger menu animation

      // Toggle the submenu when a menu item with children is tapped/clicked
      subMenuMobileLinks.forEach((link) => {
        link.addEventListener("click", () => {
          link.classList.toggle("is-submenu-open");
        });
      });

      /* Links animation
      links.forEach((link, index) => {
        if(link.style.animation) {
          link.style.animation = '';
        } else {
          // Animate each link in one after the other
          link.style.animation = `navLinkFade 0.5s ease forwards ${index / 4 + 0.5}s`;
        }
      });
      */
    });
  }
};

export default initMenu;
